import { useState, type FunctionComponent } from 'react'
import { ellipsedText } from '../../const/EllipsedTextHelper'
import { InternalLink } from '../../const/Links'
import type { ItemCategoryResult } from '../../data/ItemCategoryFragment'
import { CardMedia } from './CardMedia'
import { Hidden } from './Hidden'
import { ShowMoreLessButton } from './ShowMoreLessButton'

type CardMediaGroupProps = {
	categories: ItemCategoryResult[]
}

export const CardMediaGroup: FunctionComponent<CardMediaGroupProps> = ({ categories }) => {
	const lastCharacterVisible = 74
	const [isAllVisible, setIsAllVisible] = useState(false)
	const listedCategories = isAllVisible ? categories : categories.slice(0, 3)

	return (
		<div id="anchorCardMedia">
			<Hidden breakpoint="mobileDown">
				{categories.map((category) => (
					<CardMedia
						key={category.id}
						title={category.name}
						lead={
							category.shortDescription && category.shortDescription.length > lastCharacterVisible
								? ellipsedText(category.shortDescription, lastCharacterVisible)
								: category.shortDescription
						}
						url={`${InternalLink.IngredientCategory}${category.slug}`}
						imageUrl={category.image?.url}
					/>
				))}
			</Hidden>
			<Hidden breakpoint="mobileUp">
				{listedCategories.map((category) => (
					<CardMedia
						key={category.id}
						title={category.name}
						url={`${InternalLink.IngredientCategory}${category.slug}`}
						imageUrl={category.image?.url}
					/>
				))}
				<ShowMoreLessButton
					anchorId="anchorCardMedia"
					moreIsVisible={!isAllVisible}
					onClick={() => setIsAllVisible(!isAllVisible)}
				/>
			</Hidden>
		</div>
	)
}
